import React from "react";
import logo from "../assets/images/oba-hortifruti.png";

type BuscaInternaProps = {
  setBuscaTexto: any;
};

type BuscaInternaState = {
};


class BuscaInterna extends React.Component<BuscaInternaProps, BuscaInternaState> {

  render(): any {
    return (
      <div className="search">
        <div className="form">
          <img src={logo} alt="Oba" className="logo" />
          <input
            type="text" name="search" id="search" className="place"
            onChange={(e) => this.props.setBuscaTexto(e.target.value as string) }
            style={{ fontFamily: "Raleway, Arial, FontAwesome" }}
            placeholder="O que você procura" />
          <button>
            <i className="fas fa-search"></i>
          </button>
        </div>
      </div>
    );
  }
}

export default BuscaInterna;






